import { useMutation } from "@tanstack/react-query";
import * as Brm from "services/brm";

/**
 * Deletes an categroization  (impact statement) with the given uuid of selected element
 */
export const deleteCategorization = ({ securityObjectiveId, elementId }) => {
  return Brm.categorizedEntityApi.removeCategorizedEntityCategorization(elementId, securityObjectiveId);
};

/**
 * Custom hook to delete/ remove a categoriization for a selected element
 */
export const useDeleteCategorization = ({ config = {} }) => {
  return useMutation({
    ...config,
    mutationFn: deleteCategorization,
  });
};
